import { render, staticRenderFns } from "./BudgetDashboard.vue?vue&type=template&id=815fdeec&"
import script from "./BudgetDashboard.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('815fdeec')) {
      api.createRecord('815fdeec', component.options)
    } else {
      api.reload('815fdeec', component.options)
    }
    module.hot.accept("./BudgetDashboard.vue?vue&type=template&id=815fdeec&", function () {
      api.rerender('815fdeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/BudgetDashboard.vue"
export default component.exports